import { getHiddenInfoSellerTemplateURL } from '../../../configuration/Configuration.js';
import rejectNonOkResponse from '../rejectNonOkResponse.js';

export default async (sellerRef, maxWidth) =>
  (await rejectNonOkResponse(fetch(getHiddenInfoSellerTemplateURL({ sellerRef, maxWidth })))).text();
